import {
  OnEmptySaleResourcesError,
  OnResourceFetched,
  OnResourceFetchError,
  OnViewedProductSelection
} from './resources.types'

export const RESOURCE_FETCHED = 'RESOURCE_FETCHED'
export const FETCH_RESOURCE_ERROR = 'FETCH_RESOURCE_ERROR'
export const EMPTY_SALE_RESOURCES_ERROR = 'EMPTY_SALE_RESOURCES_ERROR'
export const VIEWED_PRODUCT_SELECTION = 'VIEWED_PRODUCT_SELECTION'

export const onResourceFetched: OnResourceFetched = (type, saleKey, key, response) => ({
  payload: { key, response, saleKey, type },
  type: RESOURCE_FETCHED
})

export const onViewedProductSelection: OnViewedProductSelection = (viewedProduct, position) => ({
  payload: { ...viewedProduct, position },
  type: VIEWED_PRODUCT_SELECTION
})

export const onEmptySaleResourcesError: OnEmptySaleResourcesError = () => ({
  payload: { type: 'sale' },
  type: EMPTY_SALE_RESOURCES_ERROR
})

export const onResourceFetchError: OnResourceFetchError = (error, type, key) => ({
  payload: { error, key, type },
  type: FETCH_RESOURCE_ERROR
})
